<template>
  <div>
    <div class="default-assessment-info">
      <img v-lazy="localImg('EmptyQuestion.svg')" alt="" />

      <div class="topic-title font-weight-bold color_text text-center">
        No Questions Found
      </div>

      <div class="text-info color_text text-center">
        While we work to make questions available for all topics, you can create
        your own questions, to test your students.
      </div>

      <div class="d-flex justify-content-center">
        <router-link
          :to="{ name: create_question_link }"
          class="btn btn-md btn-accent font-weight-bold brand_navy"
          >Create Questions</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultInfo",

  created() {
    this.getAccountType();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      if (this.account_type === "school") {
        this.create_question_link = "SchoolCreateQuestion";
        this.content_library_link = "SchoolContentLibrary";
        this.redirect_url = "SchoolHomework";
      } else if (this.account_type === "teacher") {
        this.create_question_link = "TeacherCreateQuestion";
        this.content_library_link = "TeacherContentLibrary";
        this.redirect_url = "TeacherHomework";
      }
    },
  },
};
</script>

<style lang="scss">
.default-assessment-info {
  @include flex_column_center;
  height: 55vh;

  img {
    @include equal_min_edge(80);
    @include breakpoint_max(sm) {
      @include equal_min_edge(70);
    }
  }

  .topic-title {
    font-size: 16px;
    line-height: 160%;
    margin-top: 20px;
    margin-bottom: 20px;

    @include breakpoint_max(lg) {
      font-size: 15px;
    }

    @include breakpoint_max(sm) {
      font-size: 14px;
    }
  }

  .text-info {
    width: 50%;
    font-size: 15px;
    line-height: 160%;
    margin-bottom: 30px;

    @include breakpoint_max(lg) {
      width: 70%;
      font-size: 14px;
    }

    @include breakpoint_max(sm) {
      margin-bottom: 20px;
      width: 85%;
      line-height: 19px;
      font-size: 12px;
    }
  }

  .btn {
    @include breakpoint_max(sm) {
      font-size: 9.25px !important;
      padding: 10px 19px !important;
    }
  }
}
</style>
